import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'pages.scorecards.title',
    defaultMessage: 'Scorecards',
  },
  editScorecard: {
    id: 'pages.scorecards.editScorecard',
    defaultMessage: 'Edit Scorecard',
  },
  exportScorecard: {
    id: 'pages.scorecards.exportScorecard',
    defaultMessage: 'Export Scorecard',
  },
  deleteScorecard: {
    id: 'pages.scorecards.deleteScorecard',
    defaultMessage: 'Delete Scorecard',
  },
  revertToActive: {
    id: 'pages.scorecards.revertToActive',
    defaultMessage: 'Revert Scorecard to Active State',
  },
  sendBackToEmployee: {
    id: 'pages.scorecards.sendBackToEmployee',
    defaultMessage: 'Send back to employee',
  },
  revertToDraft: {
    id: 'pages.scorecards.revertToDraft',
    defaultMessage: 'Revert Scorecard to Draft state',
  },
  requestFeedback: {
    id: 'pages.scorecards.requestFeedback',
    defaultMessage: 'Request Feedback',
  },
  submitForReview: {
    id: 'pages.scorecards.submitForReview',
    defaultMessage: 'Submit for Review',
  },
  approveGoals: {
    id: 'pages.scorecards.approveGoals',
    defaultMessage: 'Approve Goals',
  },
  gatherMoreFeedback: {
    id: 'pages.scorecards.gatherMoreFeedback',
    defaultMessage: 'Gather more Feedback',
  },
  sentimentAboveExpectations: {
    id: 'pages.scorecards.sentimentAboveExpectations',
    defaultMessage: 'Above expectations',
  },
  sentimentMeetsExpectations: {
    id: 'pages.scorecards.sentimentMeetsExpectations',
    defaultMessage: 'Meets expectations',
  },
  sentimentBelowExpectations: {
    id: 'pages.scorecards.sentimentBelowExpectations',
    defaultMessage: 'Below expectations',
  },
  buttonsEmptyAttainmentTooltip: {
    id: 'pages.scorecards.buttonsEmptyAttainmentTooltip',
    defaultMessage:
      '{goalNames} goals contain metric subgoals with an empty Attainment. Fill in Target, Actual and Performance factor for each of them before completing the Scorecard.',
  },
  stopFeedbackGathering: {
    id: 'pages.scorecards.stopFeedbackGathering',
    defaultMessage: 'Stop Feedback Gathering',
  },
  confirmDeletePendingRequestText: {
    id: 'pages.scorecards.confirmDeletePendingRequestText',
    defaultMessage:
      'Are you sure you want to complete the Scorecard without receiving feedback from below Reviewers?',
  },
  confirmStopFeedbackGatheringText: {
    id: 'pages.scorecards.confirmStopFeedbackGatheringText',
    defaultMessage:
      'Are you sure you want to stop feedback gathering without receiving feedback from below Reviewers? Their Feedback Requests will be cancelled and they will not be able to provide Feedback for this crew member.',
  },
  confirmCompleteText: {
    id: 'pages.scorecards.confirmCompleteText',
    defaultMessage:
      'You are about to turn the Scorecard into the final, Completed state. The Employee will be notified that their performance review is complete. Are you sure you want to proceed?',
  },
  confirmGatherMoreFeedbacksText: {
    id: 'pages.scorecards.confirmGatherMoreFeedbacksText',
    defaultMessage:
      'You are about to reopen this Scorecard for additional feedback. Existing feedback will be preserved. Are you sure you want to proceed?',
  },

  confirmGoalsPreparedText: {
    id: 'pages.scorecards.confirmGoalsPreparedText',
    defaultMessage:
      "You are about to confirm your goals and request their review from your People Manager. After requesting a review, you won't be able to adjust your goals details. To make further updates you need to request your People Manager enable you to do this and pass approval flow once again. You still will be able to adjust goals reviewers and select allocated projects in the Customer Satisfaction goal.{br}{br}Are you sure you want to proceed?",
  },
  confirmApproveGoalsText: {
    id: 'pages.scorecards.confirmApproveGoalsText',
    defaultMessage:
      'You are about to approve Scorecard goals for the Employee for the current Review Cycle. Employee shall be notified of this action as a confirmation that you are aligned on the goals structure and details, and Employee can start working towards them. You still will be able to adjust Scorecard goals if required, or enable Employee to make changes and pass approval flow once again.{br}{br}Are you sure you want to proceed?',
  },
  noScorecards: {
    id: 'pages.myTeam.noScorecards',
    defaultMessage: 'No scorecards yet',
  },
  confirmSendForFeedbackText: {
    id: 'pages.scorecards.confirmSendForFeedbackText',
    defaultMessage:
      'Once you request feedback you will no longer be able to edit goals structure, names and descriptions. You still will be able to adjust goals weights and add extra Reviewers.{br}{br}Are you sure you want to proceed?',
  },
  confirmDeleteScorecardText: {
    id: 'pages.scorecards.confirmDeleteScorecardText',
    defaultMessage:
      'You are about to delete Scorecard for {fullName}. Scorecard data, including configured goals, will be permanently deleted.{br}{br}Are you sure you want to proceed?',
  },
  confirmRevertToActiveText: {
    id: 'pages.scorecards.confirmRevertToActiveText',
    defaultMessage:
      'You are about to revert Scorecard back into an Active state that will enable an employee to adjust goals structure and details. {isFeedbackActive, select, true { All previously provided feedbacks will be cleared out and reviewers will need to provide a feedback once again. } other {} } After this action, you will further need to pass Scorecard approval flow with your subordinate. You should be jointly aligned on these steps.{br}{br}Are you sure you want to proceed?',
  },
  sprDescription: {
    id: 'pages.scorecards.sprDescription',
    defaultMessage:
      'Performance Rating Description{br}{br}' +
      '5.0 - Unique, exceptional and world class and Top 1% performer; Score > 125{br}' +
      '4.5 - Exceptional performer with considerable world class achievement during review period; Score 121 - 125{br}' +
      '4.0 - Top performer during review period; Score 116 - 120{br}' +
      '3.5 - Above average performer during period; Score 108 - 115{br}' +
      '3.0 - Medium-to-good performer during review period; Score 98 - 107{br}' +
      '2.5 - Slightly below average performer during period; Score 85 - 97{br}' +
      '2.0 - Below average performance during period; Score 75 - 84{br}' +
      '1.0 - Immediate termination; Score < 75',
  },
  editMyScorecard: {
    id: 'pages.scorecards.editMyScorecard.title',
    defaultMessage: 'Edit My Scorecard',
  },
  viewMyScorecard: {
    id: 'pages.scorecards.viewMyScorecard.title',
    defaultMessage: 'My Scorecard',
  },
  viewScorecard: {
    id: 'pages.scorecards.viewScorecard',
    defaultMessage: 'View Scorecard',
  },
  myScorecardFor: {
    id: 'pages.scorecards.myScorecardFor',
    defaultMessage: 'My Scorecard for',
  },
  updatedField: {
    id: 'pages.scorecards.updatedField',
    defaultMessage: `<strong>{field}</strong> updated: <strong>{prev}</strong> → <strong>{curr}</strong>`,
  },
  updatedFieldStatus: {
    id: 'pages.scorecards.updatedFieldStatus',
    defaultMessage: `<strong>{field}</strong> updated: <old></old> → <new></new>`,
  },
  updatedParamsField: {
    id: 'pages.scorecards.updatedParamsField',
    defaultMessage: `<strong>''{field}''</strong> setting <strong>{curr}</strong>`,
  },
  updatedSubgoalDescription: {
    id: 'pages.scorecards.updatedSubgoalDescription',
    defaultMessage: 'Subgoal:{br}<i>{name}</i>',
  },
  deletedSubgoalDescription: {
    id: 'pages.scorecards.deletedSubgoalDescription',
    defaultMessage: 'Subgoal <i>{name}</i> deleted',
  },
  createdSubgoalDescription: {
    id: 'pages.scorecards.createdSubgoalDescription',
    defaultMessage: 'Subgoal created:',
  },
  updatedGoalDescription: {
    id: 'pages.scorecards.updatedGoalDescription',
    defaultMessage: 'Goal:{br}<i>{name}</i>',
  },
  deletedGoalDescription: {
    id: 'pages.scorecards.deletedGoalDescription',
    defaultMessage: 'Goal <i>{name}</i> deleted',
  },
  createdGoalDescription: {
    id: 'pages.scorecards.createdGoalDescription',
    defaultMessage: 'Goal created:',
  },
  multiplier: {
    id: 'pages.scorecards.multiplier',
    defaultMessage: 'Multiplier',
  },
  metricFormat: {
    id: 'pages.scorecards.metricFormat',
    defaultMessage: 'Metric Format',
  },
  metricTarget: {
    id: 'pages.scorecards.metricTarget',
    defaultMessage: 'Metric Target',
  },
  metricActual: {
    id: 'pages.scorecards.metricActual',
    defaultMessage: 'Metric Actual',
  },
  metricPerformanceFactor: {
    id: 'pages.scorecards.metricPerformanceFactor',
    defaultMessage: 'Metric Performance Factor',
  },
  metricAttainment: {
    id: 'pages.scorecards.metricAttainment',
    defaultMessage: 'Attainment',
  },
  metricAssessment: {
    id: 'pages.scorecards.metricAssessment',
    defaultMessage: 'People Manager Assessment',
  },
  metricAssessmentApproved: {
    id: 'pages.scorecards.metricAssessmentApproved',
    defaultMessage: 'Approved Assessment',
  },

  setAsReviewer: {
    id: 'pages.scorecards.setAsReviewer',
    defaultMessage: '{userFullName} added for:',
  },
  deleteAsReviewer: {
    id: 'pages.scorecards.deleteAsReviewer',
    defaultMessage: '{userFullName} removed from:',
  },
  finalizedComment: {
    id: 'pages.scorecards.finalizedComment',
    defaultMessage: 'Finalized Comment',
  },
  assessmentScore: {
    id: 'pages.scorecards.assessmentScore',
    defaultMessage: 'Assessment Score',
  },
  countriesRemovedFromTemplate: {
    id: 'pages.scorecards.countriesRemovedFromTemplate',
    defaultMessage:
      'Following locations were removed from the Template as currently hold no employees for selected Department: {countries}',
  },
  assessmentScoreFrom: {
    id: 'pages.scorecards.assessmentScoreFrom',
    defaultMessage: 'Assessment Score from {firstName} {lastName}',
  },
  savedComment: {
    id: 'pages.scorecards.savedComment',
    defaultMessage: 'Saved Comment',
  },
  savedCommentFrom: {
    id: 'pages.scorecards.savedCommentFrom',
    defaultMessage: 'Saved Comment from {firstName} {lastName}',
  },
  updatedComment: {
    id: 'pages.scorecards.updatedComment',
    defaultMessage: 'Updated Comment',
  },
  updatedCommentFrom: {
    id: 'pages.scorecards.updatedCommentFrom',
    defaultMessage: 'Updated Comment from {firstName} {lastName}',
  },
  noReviewers: {
    id: 'pages.scorecards.noReviewers',
    defaultMessage: "Ooops. It's no one here!",
  },
  restoreScorecardTitle: {
    id: 'pages.scorecards.restoreScorecardTitle',
    defaultMessage: 'Restore Scorecard for {name}',
  },
  restoreScorecardText: {
    id: 'pages.scorecards.restoreScorecardText',
    defaultMessage:
      'You are about to restore previously deleted Scorecard for {name}. After that action it will become visible for this person and their People Manager and will be in Active state.{br}{br}Are sure you want to proceed?',
  },
  restoreScorecardToast: {
    id: 'pages.scorecards.restoreScorecardToast',
    defaultMessage: 'Scorecard for {name} was successfully restored.',
  },
  versionLockPopupTitle: {
    id: 'pages.scorecards.versionLockPopupTitle',
    defaultMessage: "Can't save Scorecard",
  },
  versionLockPopupContent: {
    id: 'pages.scorecards.versionLockPopupContent',
    defaultMessage:
      "This Scorecard was edited by {name} at {date}.{br}We can't apply your changes as it will overwrite the previous one.{br}Please contact {name} to agree on updates or open this Scorecard in a new tab and move your changes there.",
  },
  revertToActiveNoCM: {
    id: 'pages.scorecards.revertToActiveNoCM',
    defaultMessage:
      'This employee doesn’t have an assigned People Manager. Scorecard can’t be reverted to Active state',
  },
  feedbackWasRejected: {
    id: 'pages.scorecards.feedbackWasRejected',
    defaultMessage: 'Feedback request was rejected.',
  },
  subgoalNaOrDontKnowTooltip: {
    id: 'pages.scorecards.subgoalNaOrDontKnowTooltip',
    defaultMessage:
      'This subgoal has only "N/A or Don\'t know" feedback or no feedback at all. Calculated score is 0, which breaks the Scorecard Total Score. Set its weight to 0 so it does not affect the Total Score.',
  },
  buttonsNaOrDontKnowTooltip: {
    id: 'pages.scorecards.buttonsNaOrDontKnowTooltip',
    defaultMessage:
      '{goalNames} goals contain subgoals with only "N/A or Don\'t know" or no feedbacks at all. Calculated score is 0, which breaks the Scorecard Total Score. Set their weight to 0 so they do not affect the Total Score.',
  },
  keyReviewerMarkTooltip: {
    id: 'pages.scorecards.keyReviewerMarkTooltip',
    defaultMessage:
      "Click to mark this Reviewer as a Key Reviewer. This will make weight of this person's feedback as 50%. Consider this option in case this reviewer can provide the most valuable feedback regarding this Goal. You can mark only 1 Reviewer as Key Reviewer.",
  },
  keyReviewerUnmarkTooltip: {
    id: 'pages.scorecards.keyReviewerUnmarkTooltip',
    defaultMessage: 'Click to unmark this Reviewer as a Key Reviewer.',
  },
  keyReviewerAlreadySelectedTooltip: {
    id: 'pages.scorecards.keyReviewerAlreadySelectedTooltip',
    defaultMessage:
      "You can select only 1 Key Reviewer, already selected Key Reviewer will be unselected if you'll select this one.",
  },
  keyReviewerSetAsKey: {
    id: 'pages.scorecards.keyReviewerSetAsKey',
    defaultMessage: '{userFullName} was set as Key Reviewer for goal:',
  },
  keyReviewerUnsetAsKey: {
    id: 'pages.scorecards.keyReviewerUnsetAsKey',
    defaultMessage: '{userFullName} was unset as Key Reviewer for goal:',
  },
  goal: {
    id: 'pages.scorecards.goal',
    defaultMessage: 'Goal',
  },
  subgoal: {
    id: 'pages.scorecards.subgoal',
    defaultMessage: 'Subgoal',
  },
  noComments: {
    id: 'pages.scorecards.noComments',
    defaultMessage: 'No comments yet',
  },
  addAComment: {
    id: 'pages.scorecards.addAComment',
    defaultMessage: 'Add a comment...',
  },
  commentsTooltip: {
    id: 'pages.scorecards.commentsTooltip',
    defaultMessage:
      'This feature allows the <b>Crew Member and Manager</b> to openly discuss the <b>Actual / Self-Assessment</b> results in one shared space. It supports comments with clarifications, alignment on expectations, and additional context before final outcomes are confirmed.',
  },
  createScorecardError: {
    id: 'pages.scorecards.createScorecard.error',
    defaultMessage: 'Unable to create the scorecard. Please try again.',
  },
});
